import React from 'react';
import './titleCard-mobile.css'
const TitleCardMobile = ({value, styleClass}) => {
    return (
        <>
            <p  className={styleClass}>{value}</p>
           
        </>
    );
}

export default TitleCardMobile;
